import React, { useState } from "react";
import {
  Spinner,
  Container,
  Row,
  Col,
  ProgressBar,
  Table,
} from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import useGraphWithMsal from "../hooks/useGraphWithMsal";
import axios from "axios";
import sendPrivateMessage from "./SendPrivateMessage";
import "../styles/App.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PacmanLoader from "react-spinners/PacmanLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";

export const WeeklyCheck = () => {
  const { accounts, instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [messages, setMessages] = useState([]);
  const [usersToDisplay, setusersToDisplay] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [incompleteUsers, setIncompleteUsers] = useState([]);
  const [progress, setProgress] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isDataFetched, setDataFetched] = useState(false);

  const GRAPH_BASE_URL = process.env.REACT_APP_GRAPH_BASE_URL;
  const TENANT_ID = process.env.REACT_APP_TENANT_ID;
  const TEAM_ID = process.env.REACT_APP_TEAM_ID;
  const CHANNEL_ID = process.env.REACT_APP_CHANNEL_ID;

  const endpoint = `${GRAPH_BASE_URL}/tenants/${TENANT_ID}/teams/${TEAM_ID}/channels/${CHANNEL_ID}/messages`;
  const scopes = ["https://graph.microsoft.com/.default"];

  const tokens = {
    staticToken: process.env.REACT_APP_STATIC_TOKEN,
    accountId: process.env.REACT_APP_ACCOUNT_ID,
  };

  const { error, result, execute } = useGraphWithMsal(
    {
      scopes: scopes,
    },
    endpoint
  );

  const getPreviousMonday = () => {
    const date = new Date();
    const day = date.getDay();
    const difference = date.getDate() - day - 7 + (day === 0 ? -6 : 1); // adjust when day is Sunday
    return new Date(date.setDate(difference));
  };

  const getPreviousSunday = () => {
    const date = new Date();
    const day = date.getDay();
    const difference = date.getDate() - day - (day === 0 ? 7 : 0); // Subtract the current day number from the current date to get the previous Sunday, and if it's already Sunday, subtract an additional 7 days to get the previous Sunday
    return new Date(date.setDate(difference));
  };

  const setPreviousWeek = () => {
    setStartDate(getPreviousMonday());
    setEndDate(getPreviousSunday());
  };

  async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function getUsers() {
    const response = await axios.get(
      "https://api.harvestapp.com/v2/users?is_active=true",
      {
        headers: {
          Authorization: `Bearer ${tokens.staticToken}`,
          "Harvest-Account-Id": `${tokens.accountId}`,
        },
        params: {
          per_page: 2000,
        },
      }
    );

    return response.data.users.map((user) => ({
      id: user.id.toString(),
      first_name: user.first_name,
      last_name: user.last_name,
      is_contractor: user.is_contractor,
      weekly_capacity: user.weekly_capacity / 3600, // convert seconds to hours
    }));
  }

  const sendPrivateMessages = async () => {
    try {
      for (let user of incompleteUsers) {
        const userId = await getIdFromUserNameAndSurname(
          user.first_name,
          user.surname
        );
        if (userId) {
          const message = `Dear ${user.first_name}, you did not complete your timesheet for this week. Please complete your timesheet and submit it before the end of the day.`;
          await sendPrivateMessage(
            activeAccount.localAccountId,
            userId,
            message,
            execute
          );
        }
      }

      alert("Private messages sent successfully!");
    } catch (error) {
      alert("An error occurred while sending private messages!");
    }
  };

  async function getIdFromUserNameAndSurname(givenName, surname) {
    const endpoint = `https://graph.microsoft.com/v1.0/users?$filter=givenName eq '${givenName}' and surname eq '${surname}'&$select=id`;
    const data = await execute("GET", endpoint, null);
    const jsonData = await data.json();
    if (jsonData.value && jsonData.value.length > 0) {
      return jsonData.value[0].id;
    } else {
      console.log(
        `Cannot find user with given name: ${givenName} and surname: ${surname}`
      );
    }
  }

  async function retrieveTimesheet() {
    setIsLoading(true);
    const USERS = await getUsers();
    const newMessages = [];
    const incompleteUsers = [];
    const usersToDisplay = [];

    for (let [index, user] of USERS.entries()) {
      if (user.is_contractor === false) {
        const userId = user.id;
        const response = await axios.get(
          "https://api.harvestapp.com/v2/time_entries",
          {
            headers: {
              Authorization: `Bearer ${tokens.staticToken}`,
              "Harvest-Account-Id": `${tokens.accountId}`,
            },
            params: {
              user_id: userId,
              from: startDate,
              to: endDate,
            },
          }
        );

        const timeEntries = response.data.time_entries;
        if (timeEntries.length > 0) {
          // Calculate total hours for the week and validate hours per day
          let totalHours = 0;
          const dailyHours = {};

          for (const entry of timeEntries) {
            if (!dailyHours[entry.spent_date]) {
              dailyHours[entry.spent_date] = 0;
            }
            dailyHours[entry.spent_date] += entry.hours;
            totalHours += entry.hours;
          }

          if (totalHours >= user.weekly_capacity) {
            //newMessages.push(`User ${user.first_name} ${user.last_name} (ID: ${user.id}) has completed their timesheet for the week.`);
          } else {
            newMessages.push(
              `The following user(s) ${user.first_name} ${user.last_name} (ID: ${user.id}) has not completed their timesheet for the week. Total hours: ${totalHours}h.`
            );
            incompleteUsers.push({
              first_name: user.first_name,
              surname: user.last_name,
            });
            usersToDisplay.push({
              user: ` ${user.first_name} ${user.last_name}`,
              hours: totalHours,
            });
          }

          setProgress(((index + 1) / USERS.length) * 100);
        }
      }
      await sleep(200);
    }

    setusersToDisplay(usersToDisplay);
    setMessages(newMessages);
    setIncompleteUsers(incompleteUsers);
    setIsLoading(false);
    setDataFetched(true);
  }

  const postToTeams = async () => {
    if (incompleteUsers.length === 0) {
      alert("All users have completed their timesheet for the current week.");
      return;
    } else {
      const mentions = [];
      let mentionContent = "The following user(s): ";

      for (let i = 0; i < incompleteUsers.length; i++) {
        const user = incompleteUsers[i];
        try {
          const userId = await getIdFromUserNameAndSurname(
            user.first_name,
            user.surname
          );

          if (userId) {
            mentionContent += `<at id="${i}">${user.first_name} ${user.surname}</at>, `;

            mentions.push({
              id: i,
              mentionText: user.first_name + " " + user.surname,
              mentioned: {
                user: {
                  displayName: user.first_name + " " + user.surname,
                  id: userId,
                  userIdentityType: "aadUser",
                },
              },
            });
          }
        } catch (e) {
          console.log(e);
        }
      }

      if (incompleteUsers.length === 1)
        mentionContent =
          mentionContent.slice(0, -2) +
          " has not completed the timesheet for the current week. Please complete your timesheet and submit it before the end of the day.";
      else
        mentionContent =
          mentionContent.slice(0, -2) +
          " have not completed the timesheet for the current week. Please complete your timesheet and submit it before the end of the day.";

      const postData = {
        body: {
          contentType: "html",
          content: mentionContent
        },
        mentions: mentions
      };
      const response = await execute("POST", endpoint, postData);

      if (response) {
        alert("Message posted to Teams successfully!");
      } else {
        alert("Failed to post the message to Teams.");
      }
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col md="auto">
          <h1
            className="center-text title"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FontAwesomeIcon
              icon={faCalendarCheck}
              className="labelColor mr-2"
            />
            Weekly Check
          </h1>
          <h2 className="center-text labelColor">
            Select the start and end dates for the timesheet period you want to
            check.
          </h2>
          <Row className="align-items-center justify-content-start no-wrap">
            <Col md="auto" className="mr-3">
              <label className="labelColor h2 font-weight-bold">
                Start Date
              </label>{" "}
              {/* h2 and bold added */}
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
              />
            </Col>
            <Col md="auto" className="mr-3">
              <label className="labelColor h2 font-weight-bold">End Date</label>{" "}
              {/* h2 and bold added */}
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
              />
            </Col>
            <Col md="auto" className="mr-3">
              <button onClick={setPreviousWeek} className="customButton">
                Previous Week
              </button>
            </Col>
            <Col md="auto" className="mr-3">
              <button onClick={retrieveTimesheet} className="customButton">
                Retrieve Timesheet
              </button>
            </Col>
          </Row>
          {isLoading ? (
            <Container className="text-center mt-5 centered-content">
              <PacmanLoader
                color={"#123456"}
                loading={isLoading}
                size={50}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
              <ProgressBar
                now={progress}
                className="mt-3 full-width custom-progress-bar"
              />
              <p className="mt-3 labelColor">
                Checking user timesheets... {Math.round(progress)}% completed
                {progress > 90 ? " ...almost there!" : ""}
              </p>
            </Container>
          ) : (
            <>
              {isDataFetched ? (
                usersToDisplay.length > 0 ? (
                  <>
                    <h2>
                      The following users have not completed the timesheet for
                      the week:
                    </h2>
                    <Table striped bordered hover>
                      <thead className="table-header">
                        <tr>
                          <th>Name</th>
                          <th>Total Hours</th>
                        </tr>
                      </thead>
                      <tbody>
                        {usersToDisplay.map((message, index) => (
                          <tr key={index}>
                            <td>{message.user}</td>
                            <td>{message.hours}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <Container className="text-center mt-5">
                      <button
                        onClick={postToTeams}
                        className="mt-3 customButton"
                      >
                        Post to Teams
                      </button>
                      <button
                        onClick={sendPrivateMessages}
                        className="mt-3 customButton ml-3"
                      >
                        Send Private Messages
                      </button>
                    </Container>
                  </>
                ) : (
                  <div className="text-center">
                    <h2 className="labelColor">
                      All the users have completed their timesheet for the selected week.
                    </h2>
                    <span className="labelColor" style={{ fontSize: "6rem" }}>
                      😊
                    </span>
                  </div>
                )
              ) : null}
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};
